/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/newspaper_medium'
export default icon
